module.exports = __webpack_public_path__ + "img/eyein-partner-aruba.91b62fa1.png";